var exports = {
  "I2": "xfd349460--0315f2--escrow",
  "Qs": "xfd349460--0315f2--content",
  "DD": "xfd349460--0315f2--title",
  "ne": "xfd349460--0315f2--controls",
  "A4": "xfd349460--0315f2--control",
};

module.exports = exports;
